import { apiClient } from '@app/api';
import { useLayoutEffect } from 'react';
import { useImpersonation } from '../../impersonation';

export function useImpersonationInit() {
  const { impersonatedUser } = useImpersonation();

  useLayoutEffect(() => {
    if (impersonatedUser) {
      apiClient.setAuthAs(impersonatedUser.id);
    }
  }, [impersonatedUser]);
}
